module.exports = __webpack_public_path__ + "4995c676052d719ddaab4537665bd608.png";